import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { SCREEN_CONTEXT_OMITTED_KEY } from './situationalAwarenessKeys';

// Re-adding the SDK's extendedSituationalAwareness init option means raising
// this to 20,000 to match.
export var SA_LIMIT = 10000;

// Never shed. The first three answer the coaching question; the omission marker
// earns its place because dropping it turns a screen the agent knows it is
// missing into one it will guess about.
var ESSENTIAL_KEYS = ['currentRoute', 'coachingContext', 'hasMeetingAnalysis', 'searchQuery', SCREEN_CONTEXT_OMITTED_KEY];

// Most-recoverable first: the hook re-pushes screenContext on the next registry
// change, while nothing in the extra-context store is re-derived, so dropping
// those keys is permanent for the session.
var SHED_ORDER = ['screenContext', 'calendarSettings', 'calendarLinked', 'uploadedTranscriptFileName', 'userProfile', 'transcriptInitialAnalysis'];

// Replicates the SDK's measurement: key and value lengths, not serialised JSON.
export function measureSASize(context) {
  return Object.entries(context).reduce(function (total, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return total + key.length + String(value !== null && value !== void 0 ? value : '').length;
  }, 0);
}

// Descriptors are an inventory, so a truncated list would give the agent a wrong
// screen and resolve "coach me on this" against cards the user cannot see. A
// count keeps it asking instead of guessing.
function summariseOmittedScreenContext(screenContext) {
  try {
    var descriptors = JSON.parse(screenContext);
    if (!Array.isArray(descriptors) || descriptors.length === 0) return null;
    return "".concat(descriptors.length, " items on screen, omitted for size");
  } catch (_unused) {
    return 'screen contents omitted for size';
  }
}
function shedKey(context, key) {
  var reduced = _objectSpread({}, context);
  delete reduced[key];
  if (key !== 'screenContext' || !context.screenContext) return reduced;
  var summary = summariseOmittedScreenContext(context.screenContext);
  if (!summary) return reduced;

  // The marker is a fixed cost, so on a very short descriptor list it can be
  // dearer than the screenContext it stands in for.
  var marker = _defineProperty({}, SCREEN_CONTEXT_OMITTED_KEY, summary);
  if (measureSASize(marker) >= measureSASize(_defineProperty({}, key, context.screenContext))) {
    return reduced;
  }
  return _objectSpread(_objectSpread({}, reduced), marker);
}

// Null means push nothing: the SDK validates before its store write, so a
// rejected push leaves the agent's context intact, while a smaller accepted one
// replaces it wholesale.
export function fitSituationalAwarenessPayload(context) {
  if (measureSASize(context) <= SA_LIMIT) return context;
  var candidate = context;
  var _iterator = _createForOfIteratorHelper(SHED_ORDER),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (!(key in candidate)) continue;
      candidate = shedKey(candidate, key);
      if (measureSASize(candidate) <= SA_LIMIT) return candidate;
    }

    // The extra-context store is untyped, so drop unknown keys SHED_ORDER
    // cannot name before giving up.
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var essentialsOnly = Object.fromEntries(Object.entries(candidate).filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      key = _ref4[0];
    return ESSENTIAL_KEYS.includes(key);
  }));
  return measureSASize(essentialsOnly) <= SA_LIMIT ? essentialsOnly : null;
}